module.exports = __webpack_public_path__ + "a2127e4fa3400bf96b9045dff3029f9b.svg";